module.exports = {
  experienceOptions: [
    { key: 'olderPeople', description: 'Care of older people' },
    { key: 'dementia', description: 'People with dementia' },
    { key: 'learningDisabilities', description: 'Learning disabilities' },
    { key: 'mentalDisorder', description: 'Mental disorder' },
    { key: 'terminallyIll', description: 'Care of terminally ill' },
    { key: 'deceased', description: 'Dealing with deceased' },
    { key: 'supportingCommunity', description: 'Supporting in community' },
    { key: 'money', description: 'Handling money' },
    { key: 'moving', description: 'Moving and Handling' },
    { key: 'hoist', description: 'Use of hoist' },
    { key: 'walkingAids', description: 'Walking Aids' },
    { key: 'transferAids', description: 'Slide sheers/transfer aids' },
    { key: 'wheelchair', description: 'Wheelchair' },
    { key: 'transfer', description: 'Transfer' },
    { key: 'foodAndDrink', description: 'Food and Drinks' },
    { key: 'foodHygiene', description: 'Food Hygiene Regulations' },
    { key: 'mealPrep', description: 'Meal preparation' },
    { key: 'nutrition', description: 'Fluids and nutrition' },
    { key: 'toileting', description: 'Toileting' },
    { key: 'catheter', description: 'Catheter bags' },
    { key: 'commodes', description: 'Commodes' },
    { key: 'healthAndSafety', description: 'Knowledge of Health & Safety' },
    { key: 'riskAsseessments', description: 'Risk Assessments' },
    { key: 'COSHH', description: 'COSHH' },
    { key: 'infectionControl', description: 'Infection control' },
    { key: 'dutyOfCare', description: 'Duty of care' },
    { key: 'diversity', description: 'Equality and diversity' },
    { key: 'personCentredCare', description: 'Person centred care' },
    { key: 'safeguarding', description: 'Safeguarding' },
    { key: 'firstAid', description: 'First Aid' },
    { key: 'information', description: 'Handling information' },
    { key: 'domestic', description: 'Domestic' },
    { key: 'laundry', description: 'Laundry' },
    { key: 'bedMaking', description: 'Bed making' },
    { key: 'ironing', description: 'Ironing' },
    { key: 'personalTasks', description: 'Personal Tasks' },
    { key: 'washing', description: 'Washing' },
    { key: 'bathing', description: 'Bathing' },
    { key: 'shaving', description: 'Shaving' },
    { key: 'teeth', description: 'Teeth' },
    { key: 'hair', description: 'Hair' },
    { key: 'puttingToBed', description: 'Putting to bed' },
    /*
        just keys:
          'olderPeople',
          'dementia',
          'learningDisabilities',
          'mentalDisorder',
          'terminallyIll',
          'deceased',
          'supportingCommunity',
          'money',
          'moving',
          'hoist',
          'walkingAids',
          'transferAids',
          'wheelchair',
          'transfer',
          'foodAndDrink',
          'foodHygiene',
          'mealPrep',
          'nutrition',
          'toileting',
          'catheter',
          'commodes',
          'healthAndSafety',
          'riskAsseessments',
          'COSHH',
          'infectionControl',
          'dutyOfCare',
          'diversity',
          'personCentredCare',
          'safeguarding',
          'firstAid',
          'information',
          'domestic',
          'laundry',
          'bedMaking',
          'ironing',
          'personalTasks',
          'washing',
          'bathing',
          'shaving',
          'teeth',
          'hair',
          'puttingToBed',
      */
  ],
};
